export const ArchivedInfo = () => (
  <div className="x-subtitle-archived badge badge-secondary qa-deleted-info">
    {_("Archived")}
  </div>
);
ArchivedInfo.displayName = "ArchivedInfo";
